import { render, staticRenderFns } from "./PinnacleSports.vue?vue&type=template&id=65ff00f3&"
import script from "./PinnacleSports.vue?vue&type=script&lang=js&"
export * from "./PinnacleSports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports